// extracted by mini-css-extract-plugin
export var lightMode = "_1m-0";